import React from "react";
import Hero from "../Hero";
import PluroAchievements from "../PluroHome/PluroAchievements";
import PluroDoctors from "../PluroHome/PluroDoctors";
import { Helmet } from "react-helmet";
import AboutSection from "../Section/AboutSection";
import FunFactSection from "../Section/FunFactSection/index";
import Section from "../Section";
import BlogSection from "../Section/BlogSection";
import AppointmentSection from "../Section/AppointmentSection";
import FaqSectionStyle4 from "../FaqSection/FaqSectionStyle4";
import DepartmentSection from "../Section/DepartmentSection";
import { pageTitle } from "../../helpers/PageTitle";
import FeaturesSectionStyle5 from "../Feature/FeaturesSectionStyle5";
import TeamSection from "../Section/TeamSection";
import ContactInfoSection from "../Section/ContactInfoSection";
import FeaturesSectionStyle4 from "../Feature/FeaturesSectionStyle4";
import styled from "styled-components";
import DepartmentSectionStyle5 from "../Section/DepartmentSection/DepartmentSectionStyle5";
import ReelsCarousel from "../ReelsCarousel/ReelsCarousel";

/* ---------------------------------------------------------------
   Consistent spacing scale (replaces the old inconsistent
   150-200px values that were scattered per-section at random).
   Xl = desktop, Lg = laptop/tablet-landscape, Md = tablet/mobile.
----------------------------------------------------------------- */
const SECTION_SPACING = {
  topMd: 20,
  topLg: 40,
  topXl: 80,
  bottomMd: 20,
  bottomLg: 40,
  bottomXl: 80,
};

const featureListData = [
  {
    iconUrl: "/images/home_4/compassion.svg",
    title: "Advanced Infrastructure",
    subTitle:
      "We understand that seeking medical care can be a stressful experience, and we strive to provide world-class infrastructure to achieve the best results for our patients.",

    subTitles:
      "'I got the best possible treatment and owe it to the Doctor and Staff! I sincerely followed his diagnosis and recommended treatment and it worked wonders! Very caring and concerned!'",
    ratingNumber: "5",
    Name: "Kavita Sinha",
  },
  {
    iconUrl: "/images/home_4/excellence.svg",
    title: "High IVF Success Rate",
    subTitle:
      "We believe in progressively updating our technology, sharpening our skills and streamlining our resources to deliver the highest quality of healthcare possible. We are proud and delighted to declare that we have provided consistent, excellent IVF success rates.",

    subTitles:
      "'The Gynecologist took a great care  of me throught out my pregnacies. would definitely recommend others.'",
    ratingNumber: "4.5",
    Name: "Preeti Singh",
  },
  {
    iconUrl: "/images/home_4/integrity.svg",
    title: "Cost Effective",
    subTitle: (
      <>
        {" "}
        We believe in practicing medicine with integrity and honesty. We have
        designed comprehensive, highly affordable packages with the aim of
        providing advanced fertility services to as many people as possible.{" "}
        <strong>We do ICSI for all Patients at no added cost.</strong>
      </>
    ),
    subTitles:
      "'ONe of my freind suggest this gynecologist after we had some trouble conceiving children.But now after their effective treatment I am very happy'",
    ratingNumber: "4.0",
    Name: "Sonia Mehra",
  },
  {
    iconUrl: "/images/home_4/respect.svg",
    title: "Transparency",
    subTitle:
      "We treat all individuals with respect, compassion, and kindness, regardless of their background, beliefs, or circumstances. We are transparent in our communications and decision-making processes, and we always put our patients' interests first.",
    subTitles:
      "'I got the best possible treatment and owe it to the Doctor and Staff! I sincerely followed his diagnosis and recommended treatment and it worked wonders! Very caring and concerned!'",
    ratingNumber: "5",
    Name: "Kavita Sinha",
  },
  {
    iconUrl: "/images/home_4/teamwork.svg",
    title: "Support",
    subTitle:
      "We believe in providing a comprehensive support system, thus providing everything from basic treatment to advanced care. We have a highly skilled team to ensure in-depth investigations, perfect individualized treatment plans, advanced endoscopic fertility-enhancing surgeries, the highest quality fertility treatment, and excellent management of high-risk pregnancies.",
    subTitles:
      "'The Gynecologist took a great care  of me throught out my pregnacies. would definitely recommend others.'",
    ratingNumber: "4.5",
    Name: "Preeti Singh",
  },
];
const faqData = [
  {
    title: "What services does Pluro Jabalpur IVF Centre offer?",
    content:
      "Pluro Jabalpur IVF Centre offers a range of fertility treatments and services to help individuals and couples achieve pregnancy. These services typically include  fertility testing and diagnosis, in vitro fertilization (IVF), intracytoplasmic sperm injection (ICSI), intrauterine insemination (IUI),IVF With egg and sperm donation, embryo freezing, advanced laparoscopic hysteroscopic surgeries, and counseling and support services.We also do Fertility Preservation (Egg Freezing and Sperm Freezing)",
  },
  {
    title: "How do I schedule an appointment with Pluro Jabalpur IVF Centre?",
    content:
      "To schedule an appointment with Pluro Jabalpur IVF Centre, you can visit their official website and use their online appointment booking system. Alternatively, you can call the centre directly to speak with a representative who can assist you in scheduling an appointment. It is also possible to visit the centre in person to arrange an appointment.",
  },
  {
    title: "Do you accept insurance?",
    content:
      "Pluro Jabalpur IVF Centre's policy on accepting insurance may vary, so it is best to contact the centre directly to inquire about their insurance policies. They can provide information on whether they accept your insurance plan and what services are covered. It is also advisable to check with your insurance provider to understand your coverage for fertility treatments.",
  },
  {
    title: "What should I bring to my appointment?",
    content:
      "When attending your appointment at Pluro Jabalpur IVF Centre, it is important to bring a valid ID (Adhar Card), such as a driver's license or passport, and your insurance card if applicable. Additionally, bring any relevant medical records or test results, a list of current medications you are taking, and a list of any questions or concerns you have about your treatment.",
  },
  {
    title: "How do I request a prescription refill?",
    content:
      "To request a prescription refill from Pluro Jabalpur IVF Centre, you can call the centre and speak with a nurse or medical assistant who can process your request. Some centres may also offer an online portal where you can request refills. Be sure to have your prescription information handy when making the request.",
  },
];
const blogData = [
  {
    title: "The Benefits of Mindfulness Meditation for Stress and Anxiety",
    thumbUrl: "images/blog/post_2.jpeg",
    date: "May 1, 2023",
    btnText: "Learn More",
    href: "/blog/blog-details",
    socialShare: true,
  },
];
const departmentData = [
  {
    title: "IVF",
    iconUrl: "images/home_1/department_icon_3.png",
    href: "/IVF",
  },
  {
    title: "ICSI",
    iconUrl: "images/home_1/department_icon_7.svg",
    href: "/ICSI",
  },
  {
    title: "IUI",
    iconUrl: "images/home_1/department_icon_10.svg",
    href: "/IUI",
  },
  {
    title: "IVF With Egg Donation, Sperm Donation",
    iconUrl: "images/home_1/department_icon_9.svg",
    href: "/Egg-Or-Sperm-Donation",
  },
  {
    title: "EmbryoDonation",
    iconUrl: "images/home_1/department_icon_6.svg",
    href: "/Embryo-Donation",
  },
  {
    title: "Hysteroscopy & Laparoscopy Treatment",
    iconUrl: "images/home_1/department_icon_4.svg",
    href: "/Laparoscopy",
  },
  {
    title: "Tesa / Pesa",
    iconUrl: "images/home_1/department_icon_8.svg",
    href: "/Tesa-Pesa",
  },
  {
    title: "Advanced Lap Surgeries",
    iconUrl: "images/home_1/department_icon-9.svg",
    href: "/Laparoscopy-Removal",
  },
  {
    title: "Fertility Preservation",
    iconUrl: "images/home_1/department_icon-9.svg",
    href: "/Fertility-Preservation",
  },
  {
    title: "Complete Fertility Workup",
    iconUrl: "images/home_1/department_icon_2.svg",
    href: "/Complete-Workup",
  },
];

const teamData = [
  {
    imgUrl: "/images/about/DrArchnaShrivastav.jpg",
    name: "Dr. Archana Shrivastava MBBS, DGO, D.Lap (Germany)",
    description:
      "Dr. Archana Shrivastava has 24 years of experience in Obstetrics, Gynecology, and Laparoscopy, specializing in fertility treatment and advanced laparoscopic surgeries.",
    social: [
      {
        icon: "fa6-brands:facebook-f",
        href: "https://www.facebook.com/PluroJabalpurFertilityAndIVFCentre/",
      },
      {
        icon: "fa6-brands:instagram",
        href: "https://www.instagram.com/plurojabalpur_ivf/",
      },
      {
        icon: "fa6-brands:youtube",
        href: "https://www.youtube.com/@PluroJabalpur_IVF",
      },
    ],
  },
];
const funFactData = [
  { number: "15+", title: "Years of experience", start: 0, duration: 10.5 },
  {
    number: "95%",
    title: "Patient satisfaction rating",
    start: 0,
    duration: 8.5,
  },
  {
    number: "5000+",
    title: "Patients served annually",
    start: 0,
    duration: 6.5,
  },
  {
    number: "10+",
    title: "Healthcare providers on staff",
    start: 0,
    duration: 10.5,
  },
];

const TestimonialSection = styled(Section)`
  background: url("/images/home_1/heroBg.jpeg") no-repeat left bottom;
  background-size: cover;
  padding: 40px 20px;

  .cs_section_title {
    color: #ffffff !important;
  }
  .cs_section_subtitle {
    color: #ffffff !important;
    opacity: 0.9;
  }

  @media (max-width: 767px) {
    background-position: right bottom;
    padding: 25px 10px;
  }
`;

export default function Home() {
  pageTitle("Home");
  return (
    <>
      <Helmet>
        <title>Best IVF & Fertility Clinic in Jabalpur</title>

        <meta
          name="description"
          content="The best fertility clinic in Jabalpur, offering personalised care and high success rates for effective IVF treatments at Dr. Archana Shrivastava's Fertility Center."
        />
        <link rel="canonical" href="https://www.jabalpurivfcentre.com/" />
      </Helmet>
      <Container>
        {/* Start Hero Section */}
        <Hero
          title="SPREADING THE JOY OF MOTHERHOOD"
          subTitle="We are committed to providing the best technology to achieve great results in IVF and fertility treatments for infertile couples in our city and beyond."
          bgUrl="/images/Home.jpeg"
          smallbgUrl="/images/homeMobileBanner.jpeg"
          videoBtnText="See how we work"
          videoUrl="https://www.youtube.com/embed/BTnJfdKAd3k?si=CbBTCf6YCr8YgLXu"
          infoList={[
            {
              title: "Patient Name",

              iconUrl: "/images/icons/ambulance.svg",
            },
          ]}
          dateList={[
            {
              title: "Booking Date",
              date: "dd-mm-yyyy",
              iconUrl: "/images/icons/appointment_icon_x.svg",
            },
          ]}
          contactList={[
            {
              title: "Mobile Number",
              contact: "7000XXXXXX",
              iconUrl: "/images/contact/icon_1.svg",
            },
          ]}
          btnText="Book Now"
          btnUrl="/appointments"
        />
        {/* End Hero Section */}

        {/* Start About Section */}
        <Section {...SECTION_SPACING}>
          <AboutSection
            imgUrl="/images/home_1/AboutJBpIVF.png"
            spiningImgUrl="/images/home_1/about_mini.svg"
            title="About"
            subTitle="Pluro Jabalpur Fertility Center"
            featureList={[
              {
                featureListSubTitle:
                  "Well located in the heart of Jabalpur, Madhya Pradesh, Pluro Jabalpur Fertility Center is one of the oldest and best treatment providers for infertile couples. Our areas of specialisation include advanced infertility treatments like IVF , ICSI , IUI etc or advanced laproscopic Surgeries and dealing with high-risk IVF pregnacies. We provide perfect care to the patients and help them to get rid of the problem through which they are suffering from. The technical and architectural designing of this clinic has been done specifically to provide the benefit of an excellent health care system. We are very prominent in our service. Our clinic has achieved eminence in this industry because of our clients' belief and trust. Book an appointment today for a healthier tomorrow",
              },
            ]}
          />
        </Section>
        {/* End About Section */}

        {/* Start FunFact Section */}
        <PluroAchievements
          title="Our <span>achievements</span>"
          data={funFactData}
        />
        {/* End FunFact Section */}

        {/* Start Doctor Section */}
        <PluroDoctors
          title="<span>MEET OUR</span>Expert Doctor"
          data={teamData.map((item) => ({
            imgUrl: item.imgUrl,
            name: item.name.split(" MBBS")[0],
            designation: "MBBS, DGO, D.Lap (Germany)",
            experience: "24+ yrs exp",
            description: item.description,
            social: item.social,
          }))}
        />
        {/* End Doctor Section */}

        {/* Start Reels Section */}
        <ReelsCarousel />
        {/* End Reels Section */}

        {/* Start Departments Section */}
        <Section {...SECTION_SPACING}>
          <DepartmentSection
            sectionTitle="Expertise in Treatment of"
            bgUrl="images/home_1/banner_bg1.png"
            data={departmentData}
            titleStyle={{ color: "#fff" }}
          />
        </Section>
        {/* End Departments Section */}

        {/* Start Departments Section (mobile) */}
        <Section {...SECTION_SPACING} className="d-block d-md-none">
          <DepartmentSectionStyle5
            sectionTitle="Expertise in Treatment of"
            data={departmentData}
          />
        </Section>
        {/* End Departments Section */}

        {/* Start Why Choose US Section */}
        <Section {...SECTION_SPACING} className="cs_gray_bg_1">
          <FeaturesSectionStyle5
            sectionTitle="Why Choose Us"
            data={featureListData}
          />
        </Section>
        {/* End Why Choose US Section */}

        {/* Start Testimonial */}
        <TestimonialSection>
          <FeaturesSectionStyle4
            sectionTitle="What Our Patients Say <br />About Us"
            sectionTitleUp="TESTIMONIALS"
            data={featureListData}
          />
        </TestimonialSection>
        {/* End Testimonial */}

        {/* Start Blog Section */}
        <Section {...SECTION_SPACING}>
          <BlogSection
            sectionTitle="Latest Update"
            sectionTitleUp="BLOG POSTS"
            data={blogData}
          />
        </Section>
        {/* End Blog Section */}

        {/* Start Appointment Section */}
        <Section {...SECTION_SPACING} id="appointment">
          <AppointmentSection
            sectionTitle="Appointment"
            sectionTitleUp="BOOK AN"
            imgUrl="/images/home_1/appointment_section.webp"
          />
        </Section>
        {/* End Appointment Section */}

        {/* Start FAQ Section */}
        <Section {...SECTION_SPACING}>
          <FaqSectionStyle4
            sectionTitle="Frequently Asked <br />Questions"
            data={faqData}
            faqImgUrl="/images/home_4/faq_img.jpg"
            spiningImgUrl="/images/home_1/about_mini.svg"
          />
        </Section>
        {/* End FAQ Section */}

        {/* {Start Contact Map} */}
        <Section {...SECTION_SPACING}>
          <ContactInfoSection sectionTitle="Find Us Here" />
        </Section>
        {/* {End Contact Map} */}
      </Container>
    </>
  );
}

const Container = styled.div``;
